import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import env from "@beam-australia/react-env";
import useApi from "../../../../hooks/useApi";
import useSkeleton from "../../../../hooks/useSkeleton";

import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

import helperFormats from "../../../../utils/helperFormats";

import "react-toastify/dist/ReactToastify.css";

import { atom, useAtom } from "jotai";
import { loadingState } from "../../../../states/loadingState";

const WithholdingsLinesUpdateAmount = ({ settings }) => {
  const [isLoading, setIsLoading] = useAtom(loadingState);

  const api = useApi();

  const s = useSkeleton("abm");
  const { t } = useTranslation();

  const toast = useRef(null);
  const inputTextNewAmount = useRef(null);

  const [newAmount, setNewAmount] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setNewAmount(0);
    setError(null);
  }, []);

  useEffect(() => {
    setError(null);

    if (!newAmount) {
      setError("Requerido");
      inputTextNewAmount.current.value = "0,00";
    } else if (isNaN(newAmount)) {
      setError("NAN");
    } else if (isNaN(newAmount)) {
      setError("Valor incorrecto");
    }
  }, [newAmount]);

  const onInputFocus = (args) => {
    args.target.select();
    setError("");
  };

  const onSubmit = async (data) => {
    if (error) {
      console.log(error);
    } else {
      try {
        setIsLoading(true);

        await api.put(
          `${env("API_URL")}/withholdings/updateWitholdingLineAmount/${
            settings.updateWithholdingLineId
          }`,
          JSON.stringify(newAmount),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        settings.toast.current.show({
          severity: "success",
          summary: t("forms.messages.titles.success"),
          detail: t("forms.messages.operation.success"),
          life: 3000,
        });

        settings.hideDialog();
      } catch (error) {
        settings.toast.current.show({
          severity: "error",
          summary: t("forms.messages.titles.error"),
          detail: t("forms.messages.operation.error"),
          life: 3000,
        });
      }

      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className={s.get()}>
        <div className="flex flex-column">
          <div className="flex column-gap-5">
            <div>
              <div className="flex justify-content-start align-items-end pb-2 h-3rem">
                <label>
                  {t("entities.withholdings.withholdingsLines.currentAmount")}
                </label>
              </div>
              <div>
                <InputText
                  id="currentAmount"
                  value={helperFormats.formatDecimal(
                    settings.updateWithholdingLineAmount
                  )}
                  readOnly
                />
              </div>
            </div>
            <div>
              <div className="flex justify-content-between align-items-end pb-2 h-3rem">
                <div className="flex flex-column">
                  <div className="flex justify-content-start">
                    {error && <small className="p-error">{error}</small>}
                  </div>
                  <label htmlFor="newAmount">
                    {t("entities.withholdings.withholdingsLines.newAmount")}
                  </label>
                </div>
              </div>
              <div className="form-crud">
                <InputNumber
                  inputRef={inputTextNewAmount}
                  id={newAmount}
                  value={0}
                  onValueChange={(e) => setNewAmount(e.value)}
                  mode="decimal"
                  locale="de-DE"
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  min={0}
                  max={100000}
                  onFocus={onInputFocus}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-content-between mt-4 mb-2">
            <Button
              label={t("buttons.cancel")}
              icon="pi pi-times"
              className="p-button-text btn-secondary-crud"
              onClick={() => settings.hideDialog("CANCEL")}
              type="button"
              disabled={isLoading}
            />
            <Button
              label={
                isLoading ? `${t("buttons.updating")}...` : t("buttons.update")
              }
              icon="pi pi-check"
              className=" btn btn-primary btn-primary-crud"
              onClick={onSubmit}
              disabled={isLoading || error}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WithholdingsLinesUpdateAmount;
